import React from "react";
import { HiOutlineUsers } from "react-icons/hi2";

const KaizenResults = ({
  formData,
  handleInputChange,
  handleTeamMembersChange,
  users,
  isTeamDropdownOpen,
  setIsTeamDropdownOpen,
  handleResultAreaChange,
  setFormData,
}) => {
  return (
    <div className="form-section graybox" style={{ marginTop: "20px", }}>
      <h3 className="section-title fnt20">Results & Implementation</h3>

      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label htmlFor="benchmark">Benchmark</label>
            <input
              type="text"
              id="benchmark"
              name="benchmark"
              value={formData.benchmark}
              onChange={handleInputChange}
              placeholder="e.g. 3 Per Year"
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label htmlFor="kaizenStartDate">Start Date</label>
            <input
              type="date"
              id="kaizenStartDate"
              name="kaizenStartDate"
              value={formData.kaizenStartDate}
              onChange={handleInputChange}
            />
          </div>
        </div>
        <div className="col-md-3">
          <div className="form-group">
            <label htmlFor="kaizenFinishDate">Finish Date</label>
            <input
              type="date"
              id="kaizenFinishDate"
              name="kaizenFinishDate"
              value={formData.kaizenFinishDate}
              onChange={handleInputChange}
            />
          </div>
        </div>
        <div className="col-md-3">
          <div className="form-group">
            <label htmlFor="kaizenCost">Kaizen Cost (₹)</label>
            <input
              type="number"
              id="kaizenCost"
              name="kaizenCost"
              value={formData.kaizenCost}
              onChange={handleInputChange}
              min="0"
              step="0.01"
              placeholder="0.00"
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group" style={{ flex: 2 }}>
            <label htmlFor="teamMembers">Team Members</label>
            <div className="multi-select-container">
              <div
                className="multi-select-trigger"
                onClick={() => setIsTeamDropdownOpen(!isTeamDropdownOpen)}
              >
                {formData.teamMembers && formData.teamMembers.length > 0 ? (
                  <div className="selected-tags">
                    {formData.teamMembers.map((member, index) => (
                      <span key={index} className="selected-tag">
                        {member}
                      </span>
                    ))}
                  </div>
                ) : (
                  <span style={{ color: "var(--text-tertiary)" }}>
                    Select Team Members...
                  </span>
                )}
              </div>
              <div
                className={`multi-select-dropdown ${isTeamDropdownOpen ? "open" : ""}`}
              >
                {users.map((user) => (
                  <div
                    key={user.userId}
                    className="multi-select-option"
                    onClick={() => handleTeamMembersChange(user.fullName)}
                  >
                    <input
                      type="checkbox"
                      checked={formData.teamMembers.includes(user.fullName)}
                      readOnly
                    />
                    <span>{user.fullName}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>



      <div className="form-row">
        <div className="form-group full-width">
          <label htmlFor="benefits">Benefits</label>
          <textarea
            id="benefits"
            name="benefits"
            value={formData.benefits}
            onChange={handleInputChange}
            rows={3}
            placeholder="Describe the benefits realized..."
          />
        </div>
      </div>

      <div className="form-row" style={{ marginTop: "15px" }}>
        <div className="form-group full-width kizenresultarea">
          <label>Result Area</label>
          <table className="kaizen-table">
            <tbody>
              {/* Activity Row */}
              <tr>
                <td className="header-cell">Activity</td>
                {["KK", "JH", "QM", "PM", "SHE", "OTPM", "DM", "ET"].map(
                  (act) => (
                    <td
                      key={act}
                      className={`option-cell ${formData.activity === act ? "selected" : ""}`}
                      onClick={() =>
                        setFormData((prev) => ({
                          ...prev,
                          activity: act,
                        }))
                      }
                    >
                      {act}
                    </td>
                  ),
                )}
              </tr>
              {/* Loss No./Step Row */}
              <tr>
                <td className="header-cell">Loss No./Step</td>
                {["KK", "JH", "QM", "PM", "SHE", "OTPM", "DM", "ET"].map(
                  (act) => (
                    <td key={`loss-${act}`} style={{ padding: 0 }}>
                      {formData.activity === act ? (
                        <input
                          type="text"
                          name="lossNumber"
                          value={formData.lossNumber}
                          onChange={handleInputChange}
                          style={{
                            width: "100%",
                            height: "36px",
                            border: "none",
                            textAlign: "center",
                            background: "white",
                            fontWeight: "bold",
                            outline: "none",
                          }}
                          maxLength={10}
                        //   autoFocus // Removed autoFocus to prevent jumpiness on rerender
                        />
                      ) : null}
                    </td>
                  ),
                )}
              </tr>
              {/* Result Area Row */}
              <tr>
                <td className="header-cell">Result Area</td>
                {["P", "Q", "C", "D", "S", "M"].map((area) => (
                  <td
                    key={area}
                    className={`option-cell ${formData.resultArea.includes(area) ? "selected" : ""}`}
                    onClick={() => handleResultAreaChange(area)}
                  >
                    {area}
                  </td>
                ))}
                {/* Empty cells to fill rest of the row */}
                <td
                  style={{ border: "1px solid #333", background: "#f9f9f9" }}
                ></td>
                <td
                  style={{ border: "1px solid #333", background: "#f9f9f9" }}
                ></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default KaizenResults;
